import React, { useState } from 'react';
import styles from './Agreements.module.css';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const { Group, Label, Control } = Form;

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'left',
  },
  title: {
    color: theme.palette.primary.main,
    fontFamily: 'DM Sans , sans-serif',
    fontSize: '40px',
    fontWeight: 'bold',
    textAlign: 'left',
  },
  formWrapper: {
    '& > *': {
      margin: '0 auto',
    },
  },
  description: {
    color: '#777777',
    textAlign: 'left',
  },
  label: {
    color: theme.palette.secondary.main,
  },
  limitReach: {
    color: '#ff0000',
  },
}));

const YourStory = (props) => {
  const classes = useStyles();
  const { formInfo, setFormInfo } = props;

  const [firstQLimit, setFirstQLimit] = useState(false);
  const [secondQLimit, setSecondQLimit] = useState(false);
  const [thirdQLimit, setThirdQLimit] = useState(false);

  const [firstQWordCount, setFirstQWordCount] = useState(0);
  const [secondQWordCount, setSecondQWordCount] = useState(0);
  const [thirdQWordCount, setThirdQWordCount] = useState(0);

  const LIMITCAP = '150 words limit reached';

  const handleForm = (key, event, wordCount, setWordCount, setQLimit) => {
    let value = event.target.value;
    if (value.split(' ').length == 149) {
      setWordCount(value.length);
    } else if (value.split(' ').length > 149) {
      setQLimit(true);
      value = value.slice(0, wordCount) + ' ';
    }
    const newFormInfo = { ...formInfo, [key]: value };
    setFormInfo(newFormInfo);
  };
  return (
    <div className={classes.root}>
      <p className={classes.title}>Your Story</p>
      <Form>
        <div className={classes.formWrapper}>
          <Row>
            <p className={classes.description}>
              We recommend writing your answers on a separate document, then
              pasting them in afterwards.
            </p>
          </Row>
          <Row>
            <div key={`first`} className={styles.question}>
              <Group controlId="exampleForm.ControlInput1">
                <Label className={styles.questionLabel}>
                  <Typography variant="h3" className={classes.label}>
                    Tell us about a cool project that you worked on or want to
                    work on (it doesn’t have to be technical!) (150 words max)
                  </Typography>
                  {firstQLimit && (
                    <span className={classes.limitReach}>{LIMITCAP}</span>
                  )}
                </Label>
                <Control
                  as="textarea"
                  rows={4}
                  value={formInfo.q1coolProject}
                  onChange={(e) => {
                    handleForm(
                      'q1coolProject',
                      e,
                      firstQWordCount,
                      setFirstQWordCount,
                      setFirstQLimit
                    );
                  }}
                />
              </Group>
            </div>
          </Row>
          <Row>
            <div key={`second`} className={styles.question}>
              <Group
                controlId="exampleForm.ControlInput2"
                className={styles.questionGroup}>
                <Label className={styles.questionLabel}>
                  <Typography variant="h3" className={classes.label}>
                    What do you hope to take away from Hack Western? (150 words
                    max)
                  </Typography>
                  {secondQLimit && (
                    <span className={classes.limitReach}>{LIMITCAP}</span>
                  )}
                </Label>
                <Control
                  as="textarea"
                  rows={4}
                  value={formInfo.q2takeAwayHW}
                  onChange={(e) => {
                    handleForm(
                      'q2takeAwayHW',
                      e,
                      secondQWordCount,
                      setSecondQWordCount,
                      setSecondQLimit
                    );
                  }}
                />
              </Group>
            </div>
          </Row>
          <Row>
            <div key={`bonus`} className={styles.question}>
              <Group
                controlId="exampleForm.ControlInput3"
                className={styles.questionGroup}>
                <Label className={styles.questionLabel}>
                  <Typography variant="h3" className={classes.label}>
                    What would you do if quarantine lasted for another year and
                    why? (150 words max)
                  </Typography>
                  {thirdQLimit && (
                    <span className={classes.limitReach}>{LIMITCAP}</span>
                  )}
                </Label>
                <Control
                  as="textarea"
                  rows={4}
                  value={formInfo.qbonus}
                  onChange={(e) => {
                    handleForm(
                      'qbonus',
                      e,
                      thirdQWordCount,
                      setThirdQWordCount,
                      setThirdQLimit
                    );
                  }}
                />
              </Group>
            </div>
          </Row>
        </div>
      </Form>
    </div>
  );
};

export default YourStory;
